import {
  BusinessOutlined,
  EngineeringOutlined,
  HelpOutline,
  HomeOutlined,
  KeyOutlined,
  SvgIconComponent,
} from '@mui/icons-material';

export type ConversationParticipantType =
  | 'RESIDENT'
  | 'LEASEHOLDER'
  | 'CONTRACTOR'
  | 'INTERNAL'
  | 'UNKNOWN';

const PARTICIPANT_TYPE_ICONS: Record<
  ConversationParticipantType,
  SvgIconComponent
> = {
  RESIDENT: HomeOutlined,
  LEASEHOLDER: KeyOutlined,
  CONTRACTOR: EngineeringOutlined,
  INTERNAL: BusinessOutlined,
  UNKNOWN: HelpOutline,
};

const PARTICIPANT_TYPE_LABELS: Record<ConversationParticipantType, string> = {
  RESIDENT: 'Resident',
  LEASEHOLDER: 'Leaseholder',
  CONTRACTOR: 'Contractor',
  INTERNAL: 'Internal',
  UNKNOWN: 'Unknown',
};

export const RECLASSIFIABLE_PARTICIPANT_TYPES: readonly ConversationParticipantType[] =
  ['CONTRACTOR', 'INTERNAL', 'UNKNOWN'];

export const getParticipantTypeIcon = (
  type?: string | null,
): SvgIconComponent =>
  PARTICIPANT_TYPE_ICONS[type as ConversationParticipantType] ?? HelpOutline;

export const getParticipantTypeLabel = (type?: string | null): string =>
  PARTICIPANT_TYPE_LABELS[type as ConversationParticipantType] ?? 'Unknown';

export const isReclassifiableParticipantType = (
  type?: string | null,
): boolean =>
  RECLASSIFIABLE_PARTICIPANT_TYPES.includes(
    type as ConversationParticipantType,
  );
